import {AbstractControl, ValidationErrors, Validators} from '@angular/forms';

export function CannotContainSpace(control: AbstractControl): ValidationErrors | null {
  if (control.value && (control.value as string).indexOf(' ') >= 0) {
    return {cannotContainSpace: true};
  }
  return null;
}

// !control.value.includes('.io')
export function ValidateUrl(control: AbstractControl) {
  if (control.value && !control.value.startsWith('https')) {
    return {validUrl: true};
  }
  return null;
}

// Validate Password
export class ValidatePassword {
  validPasswordPattern: string = '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*()_{}[\\]/=?+-,|.<>`~"])[a-zA-Z0-9!@#$%^&*()_{}[\\]/=?+-,|.<>`~"]+$';
}
